export default __webpack_public_path__ + "static/media/person_3@2x.75c2a69c.png";